<template>
  <Modal :showModal="showModal">
    <h3>{{ lang.delete.title }}</h3>
    <p v-html="lang.delete.content"></p>
    <div class="buttons">
      <button @click="deleteGroup" class="btn btn-primary">
        {{ lang.delete.no }}
      </button>
      <button @click="deleteGroup" class="btn btn-danger">
        {{ lang.delete.yes }} {{ form.name }}
      </button>
    </div>
  </Modal>
</template>

<script>
import axios from "axios";
import Modal from "./Modal.vue";
export default {
  components: { Modal },
  props: {
    lang: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        id: "",
        name: "",
      },
      showModal: false,
    };
  },
  mounted() {
    this.$eventBus.$on("openDeleteModal", (group) => {
      this.form.name = group.name;
      this.form.id = group.id;
      this.showModal = true;
    });

    this.$eventBus.$on("hideModals", () => {
      this.showModal = false;
    });
  },
  methods: {
    deleteGroup() {
      axios
        .post("/companies/groups/delete", {
          id: this.form.id,
        })
        .then((res) => {
          this.$emit("fetchData");
          this.showModal = false;
        })
        .catch((err) => err);
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  margin-bottom: 25px;
  line-height: 1.5rem;
  font-weight: 500;
  font-size: 1.5rem;
}
</style>